Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "pagination3499236751",
  {"root":"pagination3499236751--root"},
  "",
  8,
  "pagination3499236751"
);

